document.addEventListener('contextmenu', function(event) {
  event.preventDefault();
});


 $(document).ready(function() {
  // Toggle options display
  $('.custom-country-selector #selectButton').click(function() {
    $('.custom-country-selector .options').toggle();
  });

  // Handle selection
  $('.custom-country-selector #optionsList .options li').click(function() {
    $('.custom-country-selector #optionsList .options li').removeClass('selected');
    $(this).addClass('selected');
    $('.custom-country-selector #selectButton').text($(this).text());
    $('.custom-country-selector .options').hide();
  });
});